import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'content-body',
  name: '图文正文',
  icon: '正',
  group: '图文详情页',
  description: '渲染审核通过的富文本正文、正文图片和业务卡片。',
  defaultProps: {
    fontSize: 17,
    lineHeight: 1.8,
    showLead: true,
    imagePreview: true
  }
}
